import React, { useState } from "react";

export default function CustomInput({
  label,
  required = false,
  name,
  id,
  type = "text",
  value,
  onChange,
  autoComplete = "off",
  disabled = false,
  onKeyDown,
  error = false,
  bgColor,
  readOnly = false,
}) {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className="relative">
      <input
        disabled={disabled}
        type={type}
        name={name}
        id={id}
        onChange={onChange}
        value={value ? value : ""}
        autoComplete={autoComplete}
        className="block w-full h-52 px-12 text-xxs font-medium leading-115 tracking-05 rounded-xxxs text-gray-700 bg-transparent ring-1 ring-inset ring-gray-500 focus:outline-none focus-visible:outline-none"
        onKeyDown={onKeyDown}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        readOnly={readOnly}
        aria-invalid={error ? "true" : "false"}
        aria-describedby={error ? `${id}-error` : undefined}
      />
      <label
        className={`
            absolute left-12 pointer-events-none
            text-xxs font-medium leading-115 tracking-05 text-gray-700 ${bgColor} origin-top-left duration-100
            ${
              isFocused || value || readOnly
                ? "-top-8 scale-90 right-auto"
                : "top-18 right-32"
            }
          `}
        htmlFor={id}
      >
        {label}
        {required && <span className="text-red-500"> *</span>}
      </label>
      {error && <span className="block small text-red-500 mt-4">{error}</span>}
    </div>
  );
}
